import constants from "../constants";
import { useContext } from "react";
import AlertContext from "../context/AlertContext";
import useCommonFunctionHooks from "./useCommonFunctionHooks";
import useAxiosPrivate from "./useAxiosPrivate";

export default function UniversityListHooks() {
    const {universityList, setUniversityList} = useContext(AlertContext);
    const { getHeaderDetailsForAxios, getCatchBlockDetails} = useCommonFunctionHooks();
    const axios = useAxiosPrivate();

    const fetchUniversities = async () => {
        if(universityList?.length > 0) return;
        try {
            const response = await axios.get('/node/learner/accounts?university=true', getHeaderDetailsForAxios());

            if (response?.data?.resultCode === constants.RESULT_STATUS.SUCCESS) {
                const companyData = response.data.data.map((company) => ({
                    company_id: company.id,
                    company_name: company.name
                }));

                setUniversityList(companyData);
            }
        } catch (error) {
            getCatchBlockDetails(error);
        }
    };

    return{
        fetchUniversities
    }
}